import React from "react";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { getUser } from "store/selector";
import { getItem } from "utils/local-storage";
import { menu } from "constant/menu";
import { filteredMenu } from "utils/filtered-menu";
import { getProfile } from "view/profile/store/selector";
import { fetchProfile } from "view/profile/store/services";
import { getMissingMandatoryFields } from "utils/profile-validation";
import { errorToaster } from "utils/alerts";
import { actions } from "store/slice";

const Sidebar = React.memo(({ onClose }) => {
  const { token } = useSelector(getUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const profileObj = useSelector(getProfile);
  const filteredMenuItems = React.useMemo(
    () => filteredMenu(menu, token),
    [token]
  );

  const handleMenuClick = React.useCallback(() => {
    if (onClose) {
      onClose(); // Close the drawer if the `onClose` function is provided
    }
  }, [onClose]);

  const handleSearchProfileClick = async () => {
    handleMenuClick();
    dispatch(actions.setLoading(true));
    let currentProfile = profileObj;
    if (!currentProfile?.isProfileFetched) {
      if (token) {
        const profileData = await fetchProfile(token, dispatch);
        if (profileData && profileData.success && profileData.values && profileData.values[0]) {
          currentProfile = {
            ...currentProfile,
            ...profileData.values[0],
            isProfileFetched: true
          };
        }
      }
    }
    dispatch(actions.setLoading(false));

    const missingFields = getMissingMandatoryFields(currentProfile);
    if (missingFields.length > 0) {
      const fieldNames = missingFields.map((f) => f.label).join(", ");
      errorToaster(`Please fill in the following mandatory fields: ${fieldNames}`, 5000);

      const firstFieldId = missingFields[0].id;
      if (location.pathname !== "/profileedit") {
        navigate("/profileedit", { state: { scrollToFieldId: firstFieldId } });
      } else {
        const element = document.getElementById(firstFieldId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          element.focus();
        }
      }
    } else {
      navigate("/search-profiles");
    }
  };

  return (
    <div>
      {token && (
        <div style={{ padding: "15px 15px 0px 15px" }}>
          <h5 className="sidebar-title">User Info</h5>
          <h6>
            User Name:{" "}
            <span style={{ fontStyle: "italic", opacity: ".5" }}>
              {getItem("current_user")?.username || ""}
            </span>
          </h6>
          <h6>
            User Id:{" "}
            <span style={{ fontStyle: "italic", opacity: ".5" }}>
              {getItem("current_user")?.userId || ""}
            </span>
          </h6>
        </div>
      )}
      <div
        className="accordion-menu"
        style={{
          marginTop: !token ? "" : "10px",
          padding: "15px 15px 0px 15px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {filteredMenuItems.map(({ name, icon: Icon, link, beta }, index) => (
          <div
            key={index}
            style={{
              marginBottom: "5px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Link
                to={link}
                className="btn btn-link"
                style={{
                  display: "inline-block",
                  textDecoration: "none",
                  padding: "5px 0",
                  marginBottom: "5px",
                }}
                onClick={(e) => {
                  if (link === "/search-profiles") {
                    e.preventDefault();
                    handleSearchProfileClick();
                  } else {
                    handleMenuClick();
                  }
                }}
              >
                <Icon width={20} height={20} />
                {`  ${name}`}
              </Link>
              {beta && (
                <Tooltip title="This Feature is Under Development.">
                  <Chip label="Beta" size="small" variant="outlined" />
                </Tooltip>
              )}
            </div>
          </div>
        ))}

        {/* <div style={{ position: "absolute", bottom: 0, marginBottom: "15px" }}>
          <p className="sidebar-title">Other</p>
          <button
            className="btn btn-link btn-sm"
            style={{
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            <p className="m-0 pb-2">
            // Need to create the faclock icon component and use it here - I am going to remove this for now.
              <FontAwesomeIcon icon={faClock} /> Release Note
            </p>
          </button>
        </div> */}
      </div>
    </div>
  );
});

export default Sidebar;
